import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewGroup from 'modules/posts/components/Groups/New'

const NewGroupPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return <NewGroup onClose={() => navigate(navigation.dashboard.fullPath())} />
}

export default NewGroupPage
